<app-table
  [actionColumnWidth]="300"
  [columns]="columns"
  [loading]="loading"
  [value]="regeln"
  filename="CHOP.MASSNAHMEN_REGELN"
  sortField="massnahmeTacsId">
  <ng-template
    (onClick)="showCreateDialog()"
    appToolbarButton
    icon="fal fa-plus"
    labelKey="CHOP.CREATE_REGEL"></ng-template>
  <ng-template
    (onClick)="showEditDialog($event.row)"
    appActionButton
    icon="fal fa-pencil"
    labelKey="ACTIONS.EDIT"></ng-template>
  <ng-template
    (onClick)="delete($event.row)"
    appActionButton
    icon="fal fa-trash"
    labelKey="ACTIONS.DELETE"
    type="danger"></ng-template>
</app-table>
